(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(root) {
    if (!root || root.__pgwInit) return;
    root.__pgwInit = true;

    var header = root.querySelector('.pgw-header');
    var scrollWrap = root.closest('body') || document;
    function onScroll() {
      if (!header) return;
      var r = root.getBoundingClientRect();
      header.classList.toggle('is-scrolled', r.top < -10);
    }
    if (header) {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var video = root.querySelector('.pgw-hero__media[autoplay]');
    if (video && reduceMotion) {
      video.removeAttribute('autoplay');
      video.pause();
    }

    initFilters(root);
    initLoadMore(root);
    initLightbox(root);
  }

  function initFilters(root) {
    var chips = root.querySelectorAll('.pgw-chip');
    var yearSelect = root.querySelector('.pgw-year');
    var tiles = root.querySelectorAll('.pgw-tile[data-category]');
    var breaks = root.querySelectorAll('.pgw-break');
    if (!chips.length && !yearSelect) return;

    var state = { category: 'all', year: 'all' };

    function fadeOut(el) {
      el.classList.add('pgw-tile--fading');
      if (reduceMotion) {
        el.style.display = 'none';
      } else {
        window.setTimeout(function () {
          if (el.classList.contains('pgw-tile--fading')) el.style.display = 'none';
        }, 200);
      }
    }
    function fadeIn(el) {
      el.classList.remove('pgw-tile--fading');
      el.style.display = '';
    }

    function apply() {
      var filterActive = state.category !== 'all' || state.year !== 'all';
      tiles.forEach(function (tile) {
        var catOk = state.category === 'all' || tile.dataset.category === state.category;
        var yearOk = state.year === 'all' || tile.dataset.year === state.year;
        if (catOk && yearOk) fadeIn(tile); else fadeOut(tile);
      });
      breaks.forEach(function (b) {
        if (filterActive) fadeOut(b); else fadeIn(b);
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        state.category = chip.dataset.filterCategory;
        apply();
      });
    });
    if (yearSelect) {
      yearSelect.addEventListener('change', function () {
        state.year = yearSelect.value;
        apply();
      });
    }
  }

  function initLoadMore(root) {
    var btn = root.querySelector('.pgw-load-more');
    if (!btn) return;
    var batch = parseInt(root.dataset.loadBatch || '24', 10);
    function refresh() {
      var hidden = root.querySelectorAll('.pgw-tile--more');
      if (!hidden.length) { btn.setAttribute('hidden', ''); return; }
      btn.textContent = 'Load ' + Math.min(batch, hidden.length) + ' more ↓';
    }
    btn.addEventListener('click', function () {
      var hidden = Array.prototype.slice.call(root.querySelectorAll('.pgw-tile--more'), 0, batch);
      hidden.forEach(function (tile) { tile.classList.remove('pgw-tile--more'); });
      refresh();
    });
    refresh();
  }

  function initLightbox(root) {
    var lb = root.querySelector('.pgw-lb');
    var grid = root.querySelector('.pgw-grid');
    if (!lb || !grid) return;
    var dataEl = root.querySelector('.pgw-lb-data');
    var photos = [];
    try { photos = JSON.parse(dataEl.textContent); } catch (e) { photos = []; }

    var img = lb.querySelector('.pgw-lb__img');
    var cap = lb.querySelector('.pgw-lb__cap');
    var exhibitor = lb.querySelector('.pgw-lb__exhibitor');
    var credit = lb.querySelector('.pgw-lb__credit');
    var dl = lb.querySelector('.pgw-lb__dl');
    var counter = lb.querySelector('.pgw-lb-counter');
    var closeBtn = lb.querySelector('.pgw-lb-close');
    var prevBtn = lb.querySelector('.pgw-lb-prev');
    var nextBtn = lb.querySelector('.pgw-lb-next');
    var idx = 0;
    var lastFocused = null;

    function preload(i) {
      if (photos[i]) { var pre = new Image(); pre.src = photos[i].full; }
    }
    function render() {
      var p = photos[idx];
      if (!p) return;
      img.src = p.full;
      img.alt = p.alt || '';
      cap.textContent = p.alt || '';
      exhibitor.textContent = p.exhibitor || '';
      exhibitor.style.display = p.exhibitor ? '' : 'none';
      if (credit) {
        credit.textContent = p.credit ? 'Photo: ' + p.credit : '';
        credit.style.display = p.credit ? '' : 'none';
      }
      dl.href = p.full;
      counter.textContent = (idx + 1) + ' / ' + photos.length;
      preload((idx + 1) % photos.length);
      preload((idx - 1 + photos.length) % photos.length);
    }
    function open(i) {
      idx = i;
      lastFocused = document.activeElement;
      render();
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
      document.addEventListener('keydown', onKeydown);
    }
    function close() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }
    function nav(dir) {
      idx = (idx + dir + photos.length) % photos.length;
      render();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowLeft') { nav(-1); return; }
      if (e.key === 'ArrowRight') { nav(1); return; }
      if (e.key === 'Tab') {
        var focusable = lb.querySelectorAll('button, a[href]');
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    grid.addEventListener('click', function (e) {
      var tile = e.target.closest('.pgw-tile');
      if (!tile) return;
      var i = parseInt(tile.dataset.idx, 10);
      if (!isNaN(i)) open(i);
    });
    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { nav(-1); });
    nextBtn.addEventListener('click', function () { nav(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });

    var touchX = null;
    lb.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) nav(dx > 0 ? -1 : 1);
      touchX = null;
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('.pgw-root').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('.pgw-root') : null;
    if (root) initSection(root);
  });
  if (document.readyState !== 'loading') boot();
})();
